import React, { type ReactElement } from 'react';

import classnames from 'classnames';

import { Icon } from '../../Icon';

import styles from './AvatarInputPlaceholder.module.scss';

export type AvatarPlaceholderInputProps = {
    disabled?: boolean;
    onClick?: () => void;
};

export const AvatarPlaceholderInput = ({
    disabled,
    onClick
}: AvatarPlaceholderInputProps): ReactElement => {
    return (
        <div className={styles.root} onClick={onClick}>
            <div
                className={classnames(styles.iconWrapper, {
                    [styles.disabled]: disabled
                })}
            >
                <Icon name="s-icon-cloud-up" customSize={48} />
            </div>
        </div>
    );
};

AvatarPlaceholderInput.displayName = 'AvatarPlaceholderInput';
